import { Card, CardBody, Col } from "reactstrap";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import { controlCarouselData, slidesOnlySubTitle } from "../../../../Data/BonusUi/Slider";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { WithControlsTitle } from "../../../../Utils/Constants";

export default function WithControls() {
  return (
    <Col xl={6} xs={12}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={WithControlsTitle} subTitle={slidesOnlySubTitle} />
        <CardBody>
          <Swiper navigation={true} modules={[Navigation]}>
            {controlCarouselData.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(`slider/${item.image}`)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
}
